import { render, staticRenderFns } from "./comprehenOperateMonitorFrame.vue?vue&type=template&id=05e1fd5a&scoped=true&"
import script from "./comprehenOperateMonitorFrame.vue?vue&type=script&lang=js&"
export * from "./comprehenOperateMonitorFrame.vue?vue&type=script&lang=js&"
import style0 from "./comprehenOperateMonitorFrame.vue?vue&type=style&index=0&id=05e1fd5a&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e1fd5a",
  null
  
)

component.options.__file = "comprehenOperateMonitorFrame.vue"
export default component.exports